import React from 'react';
import { Section } from './Section';
import { Quote } from 'lucide-react';
export function FounderSection() {
  return <Section className="bg-cream" data-id="element-233">
      <div className="max-w-4xl mx-auto" data-id="element-234">
        <div className="bg-white rounded-3xl shadow-xl border border-sage overflow-hidden" data-id="element-235">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-0" data-id="element-236">
            <div className="md:col-span-2 relative bg-sage" data-id="element-237">
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&h=1000&fit=crop&crop=faces" alt="Sofía Restrepo, creadora de Adiós Hinchazón: 3-Day Reset" className="w-full h-full object-cover min-h-[400px]" data-id="element-238" />
            </div>
            <div className="md:col-span-3 p-8 md:p-10 flex flex-col justify-center" data-id="element-239">
              <Quote className="w-10 h-10 text-gold mb-4" data-id="element-240" />
              <p className="font-serif text-xl md:text-2xl text-forest leading-relaxed italic mb-6" data-id="element-241">
                "Esta guía la desarrollé después de años luchando con
                inflamación que nadie sabía explicarme. Probé de todo hasta que
                encontré la combinación exacta de alimentos que resetea el
                cuerpo en 72 horas. Hoy miles de latinas ya lo usaron."
              </p>
              <div className="border-t border-sage-dark pt-4" data-id="element-242">
                <p className="font-serif font-bold text-forest text-lg" data-id="element-243">
                  Sofía Restrepo
                </p>
                <p className="text-gray-500 text-sm" data-id="element-244">
                  Creadora de Adiós Hinchazón: 3-Day Reset
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}